import { jsxs as C, jsx as V } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const r = (H) => /* @__PURE__ */ C(o, { ...H, children: [
  /* @__PURE__ */ V("path", { d: "M3.01297 16.891V12.0167H7.90035V13.6502H5.69181C6.72429 15.1007 8.42294 16.0416 10.344 16.0416C13.4932 16.0416 16.0415 13.5065 16.0545 10.3572V10.3311H17.6881V10.3572C17.6881 14.4081 14.4081 17.7011 10.344 17.7011C8.04421 17.7011 5.99254 16.6427 4.64662 14.9832V16.891H3.01297Z" }),
  /* @__PURE__ */ V("path", { d: "M4.63333 10.3702H2.99997L3.01297 10.3572V10.3441C3.01297 6.29316 6.29298 3 10.357 3C12.6569 3 14.7085 4.05848 16.0545 5.71813V3.81033H17.6881V8.68456H17.5052V8.69756H15.8063V8.68456H12.7877V7.05106H14.996C13.9638 5.60056 12.2648 4.65965 10.344 4.65965C7.1946 4.65965 4.64662 7.19478 4.63333 10.3441V10.3702Z" })
] });
export {
  r as AvailableUpdates
};
//# sourceMappingURL=AvailableUpdates.js.map
